/* eslint-disable */
import { useEffect } from 'react';

import { activeTenant } from '@app/tenant';
import { readTenantEnv } from '@app/tenant/env';

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: (...args: any[]) => void;
  }
}

export const FacebookPixel = () => {
  const pixelId = activeTenant ? readTenantEnv(activeTenant.slug, 'FACEBOOK_TRACK_ID') : undefined;

  useEffect(() => {
    if (pixelId) {
      (function (f: Window, b: Document, e: string, v: string, n?: any, t?: HTMLScriptElement, s?: HTMLScriptElement) {
        if (f.fbq) return;

        n = f.fbq = function (...args: any[]) {
          n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0] as HTMLScriptElement;
        s.parentNode?.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

      if (window.fbq) {
        window.fbq('init', pixelId);
        window.fbq('track', 'PageView');
      }
    }
  }, []);

  return (
    <noscript>
      {pixelId ? (
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          alt="Facebook Pixel"
          src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
        />
      ) : (
        <></>
      )}
    </noscript>
  );
};
